export enum SystemEventParentType {
    NONE = 0,
    PROCESS = 1,
    ZONING_CODE = 2,
    CALCULATION_RESULT = 3
}

const SYSTEM_EVENT_PARENT_TYPE_DICTIONARY = ['None', 'Process', 'Zoning Code', 'Calculation Result'];

export function getPrettyParentType(parentType: number): string {
    return SYSTEM_EVENT_PARENT_TYPE_DICTIONARY[parentType];
}
